import React from 'react';
import { Box, Checkbox, Chip, IconButton, Tooltip, Typography } from "@mui/material";

const AllotmentCredentialRowItem = (props) => {
    
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                width: props.dynamicWidth,
                flexBasis: props.dynamicWidth,
                flexGrow: 1,
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={12}
                    fontWeight={500}
                    color="primary"
                    align='center'
                >
                    {props.displayName}
                </Typography>  
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={14}
                    textAlign={'center'}
                    fontWeight={400}
                >
                    {props.allotedValue && (props.allotedValue?.length > 0 && Array.isArray(props.allotedValue)) ? props.allotedValue.map((val) => {
                        return(<div>{val.name} - {val.value}</div>)
                    }): props.allotedValue}
                </Typography>
            </Box>
        </Box>
    )
}


export default AllotmentCredentialRowItem;